export function calculateDeliveryFee(document) {
  if (
    document.width_mm < 1200 ||
    document.length_mm < 1200 ||
    document.height_mm < 1200 ||
    document.weight_g < 35000
  ) {
    document.is_click_and_collect = true
  } else {
    document.is_click_and_collect = false
  }

  //document.is_ofm_delivery = true
  document.is_extra_delivery_fee = false

  if (document.is_dropship) {
    document.delivery_fee = 0
    //document.is_ofm_delivery = false
    document.is_extra_delivery_fee = true
    return document
  }

  if (document.is_free) {
    document.delivery_fee = 0
    return document
  }

  let weightKilo = Number(document.weight_g / 1000)
  console.log('weightKilo', weightKilo)
  console.log('document.delivery_type', document.delivery_type)
  if (document.delivery_type !== '') {
    let delivery_fee = calculateTransportationCostLF(
      document.delivery_type,
      document.weight_g
    )
    console.log('delivery_fee', delivery_fee)
    document.delivery_fee = Number(delivery_fee)
  } else if (weightKilo > 15) {
    let delivery_fee = calculateTransportationCostLF(
      document.delivery_type,
      document.weight_g
    )
    console.log('delivery_fee', delivery_fee)
    document.delivery_fee = Number(delivery_fee)
  } else {
    if (
      document.width_mm / 10 > 240 ||
      document.length_mm / 10 > 240 ||
      document.height_mm / 10 > 240
    ) {
      console.log('document.width_mm', document.width_mm)
      console.log('document.length_mm', document.length_mm)
      console.log('document.height_mm', document.height_mm)
      document.delivery_fee = 0
      //document.is_ofm_delivery = false
      document.is_extra_delivery_fee = true
      // console.log('document1', document)
      return document
    }

    let area = Number(
      document.width_mm / 10 +
        (document.length_mm / 10) * 2 +
        (document.height_mm / 10) * 2
    )
    if (area > 400) {
      document.delivery_fee = 0
      //document.is_ofm_delivery = false
      document.is_extra_delivery_fee = true
      // console.log('document2', document)
      return document
    }

    let volume = parseInt(
      Number(document.width_mm * document.length_mm * document.height_mm),
      10
    )

    let calVolume = parseInt(Number(volume / 5000000), 10)
    let calWeight = parseInt(Number(document.weight_g / 1000), 10)
    let compareVolume = calVolume > calWeight ? calVolume : calWeight
    let mark = 0
    let markoff = 0

    if (compareVolume >= 20) {
      mark = compareVolume - 20
      markoff = mark * 14
      document.delivery_fee = 120 + markoff
    } else if (compareVolume < 20 && compareVolume >= 15) {
      document.delivery_fee = 120
    } else if (compareVolume < 15 && compareVolume >= 10) {
      document.delivery_fee = 100
    } else if (compareVolume < 10 && compareVolume >= 5) {
      document.delivery_fee = 80
    } else if (compareVolume < 5) {
      document.delivery_fee = 0
    }
  }

  return document
}

function calculateTransportationCostLF(deliveryType, weightPiece) {
  // console.log('calculateTransportationCostLF deliveryType', deliveryType)
  // console.log('calculateTransportationCostLF weightPiece', weightPiece)
  let costs = 85
  switch (deliveryType) {
    case '':
    case 'LF1':
    case 'LF2':
      if (Number(weightPiece) / 1000 > 20) {
        costs += (Number(weightPiece) / 1000 - 20) * 2
      }
      // console.log('costs', costs)
      break
    case 'LF3':
      costs += 50
      break
    case 'LF4':
    case 'LF5':
      costs += 150
      break
    case 'LF6':
      costs += 120
      break
    case 'LF7':
      costs += 700
      break
    case 'LF8':
      costs += 80
      break
    default:
      break
  }
  // console.log('end costs', costs)
  return costs
}
